export default "/images/vendor/flag-icon-css/flags/4x3/kg.svg?271f0bb9f5b8a452e245d8557b5f6273";